import { WidgetColumn } from "@bryntum/grid-thin";

export class MeetingJumpColumn extends WidgetColumn {
  static get type() {
    return "meetingJump";
  }

  // @ts-ignore - Bryntum 7.x declares widgets as a property, but we need to override as accessor
  override get widgets() {
    return [
      {
        type: "button",
        text: "Meeting",
        icon: "b-fa b-fa-link",
        color: "blue",
        cls: "b-raised",
        onAction: ({ source: btn }) => {
          console.log("default meeting jump widget firing");
          // @ts-ignore
          this.grid.trigger("meetingJump", {
            type: "meetingJump",
            record: btn.cellInfo.record
          });
        }
      }
    ];
  }
}
